export default __webpack_public_path__ + "static/media/member2.d03a0686.jpg";